import React from 'react';
import { FormProvider } from 'react-hook-form';

/* Components */
import ConversionFlowSubmit from '../../conversion-flow/components/ConversionFlowSubmit';
import ConversionFlowComponentRendererVDP from './ConversionFlowComponentRendererVDP';
import ConversionBannerFinance from '../../conversion-flow/components/banners/ConversionBannerFinance';

/* Images */
import keurmerkPrivateLease from '~/../img/keurmerk-private-lease.png';

/* Utilities */
import { trans } from '~/utilities';

/* Common */
import { Button, Icon } from '~/components/common';

/* Custom */
import { activatePrefillScript } from '~/custom/prefillFormFields';

/* Icons */
import iDealIcon from '~/../symbols/iDeal.svg';

export default class ConversionFlowFormVDP extends React.Component {
    constructor(props) {
        super(props);

        this.pricePerMonth = 0;
        this.vehiclePrice = 0;
        this.financeType = 'Particulier';
    }

    componentDidMount() {
        this.activatePrefillScript();
    }

    componentDidUpdate(prevProps) {
        const { flow } = this.props;
        const { steps: prevSteps } = prevProps.flow || {};
        const { steps } = flow || {};

        const activeStep = steps?.find(step => step.active);
        const prevActiveStep = prevSteps?.find(step => step.active);

        if (activeStep !== prevActiveStep) {
            this.activatePrefillScript();
        }
    }

    activatePrefillScript() {
        const { flow } = this.props;
        if (flow && flow.steps) {
            const activeStep = flow.steps.find(step => step.active);
            if (activeStep && (!this.prevActiveStep || activeStep.position > this.prevActiveStep.position)) {
                const forms = Array.from(document.querySelectorAll('form'));
                activatePrefillScript(forms);
            }
            this.prevActiveStep = activeStep;
        }
    }

    shouldComponentUpdate(nextProps) {
        const activeStep = nextProps?.flow?.steps?.find((step) => step.active);

        if (activeStep?.position === 1) return true;

        return false;
    }

    getFinancePrice(metaData) {
        if (metaData) {
            for (const meta in metaData) {
                if (metaData[meta].hasOwnProperty('price_per_month')) {
                    this.pricePerMonth = metaData[meta].price_per_month;
                    this.financeType = metaData[meta].finance_type;
                }

                if (metaData[meta].hasOwnProperty('price')) {
                    if (metaData[meta].hasOwnProperty('actieprijs') && metaData[meta]?.actieprijs > 0) {
                        this.vehiclePrice = metaData[meta].actieprijs;
                    } else {
                        this.vehiclePrice = metaData[meta].price;
                    }
                }
            }
        }
    }

    render() {
        const { form, flow, doRequest, handleClose } = this.props;
        if (flow && flow.meta) this.getFinancePrice(flow.meta);
        let buttonMargin = true;
        if (flow?.flowName === 'lease_enquire' || flow?.flowName === 'business_lease_enquire') {
            buttonMargin = false;
        }

        return (
            <form noValidate onSubmit={form.handleSubmit(() => doRequest({ action: 'submit' }, 'submitting'))}>
                <FormProvider {...form}>
                    <div>
                        <ConversionFlowComponentRendererVDP
                            flow={flow}
                            pricePerMonth={this.pricePerMonth}
                            vehiclePrice={this.vehiclePrice}
                            loading={this.props.status !== 'idle'}
                            id="page-form"
                        />
                        {flow?.flowName === 'finance' && (
                            <>
                                <div className="d-flex align-items-center">
                                    <p className="mb-0 font-weight-bold text--lg">{this.props.status !== 'idle' ? '-' : this.pricePerMonth.toLocaleString('nl-NL')},-</p>
                                    <p className="mb-0 font-weight-normal ml-1 flow__price"> /mnd</p>
                                </div>
                                <ConversionBannerFinance />
                            </>
                        )}
                        {flow?.flowName === 'private_lease' && (
                            <div className='d-flex justify-content-between align-items-center'>
                                <div className='d-flex flex-column'>
                                    <div className="d-flex align-items-center">
                                        <p className="mb-0 font-weight-bold text--lg">{this.pricePerMonth.toLocaleString('nl-NL')},-</p>
                                        <p className="mb-0 font-weight-normal ml-1 flow__price"> /mnd</p>
                                    </div>
                                    <p className='text--xs text-muted--60 mb-0'>Alle genoemde bedragen zijn incl. BTW</p>
                                    <a href="#" className='text--xs text-base'>Hoe werkt het aanvraagproces?</a>
                                </div>
                                <img
                                    src={keurmerkPrivateLease}
                                    alt="Keurmerk Private Lease"
                                    width={60}
                                    height={79}
                                />
                            </div>
                        )}
                        {(flow?.form?.buttonLabel && flow?.flowName !== 'vdp_buy_online') && (
                            <div>
                                <ConversionFlowSubmit
                                    flow={flow}
                                    theme="success"
                                    className={`${buttonMargin ? 'mt-5' : ''} btn-block btn--submit mb-5`}
                                    handleClose={handleClose}
                                />
                            </div>
                        )}
                        {(flow?.form?.buttonLabel && flow?.flowName === 'vdp_buy_online') && (
                            <>
                                <Button
                                    className={`${buttonMargin ? 'mt-5' : ''} btn-block btn--submit mb-5`}
                                    theme="success"
                                    title={flow?.form?.buttonLabel}
                                    loading={this.props.status !== 'idle'}
                                    disabled={this.props.status !== 'idle'}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        window.location.href = (window.location.origin + window.location.pathname + '/kopen' + window.location.search);
                                    }}
                                />
                                <div className="d-flex align-items-center">
                                    <Icon
                                        theme="base"
                                        className={`icon icon--32 flex-shrink-0`}
                                        url={iDealIcon?.url}
                                    />
                                    <p className="mb-0 ml-2 flow__ideal">{trans('app.flow.ideal_label')}</p>
                                </div>
                            </>
                        )}
                    </div>
                </FormProvider>
            </form>
        )
    }
}
